import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import { useLocation, useNavigate } from "react-router-dom";

import { ProgressBar } from "react-loader-spinner";

import { Form } from "react-bootstrap";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import ResultModalWindow from "../../../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";
import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import EditableTableForKnoweledgeTest from "../../../../components/knowledgeTestComponents/commonComponents/EditableTableForKnoweledgeTest/EditableTableForKnoweledgeTest";
import SelectWithSearch from "../../../../components/GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";
import InputForForm from "../../../../components/GeneralComponents/componentsForForm/inputForForm/InputForForm";

import {
  updateExpulsionTableData,
  updateSearchCardExpulsionOrder,
  updateSearchCardOrderNum,
} from "../../../../redux/expulsionOrderReducer/actionExpulsionOrder";

import {
  columnsExpulsionOrderTable,
  optionsInputExpulsionOrder,
  updateOptions,
} from "./optionsForExpulsionOrder";

import { SET_DATA_FOR_VIEW_EXPULSION_ORDER } from "../../../../redux/types";

import {
  API_GET_EXPULSION_ORDER,
  API_SAVE_EXPULSION_ORDER,
  MAIN_URL,
  PORT_FOR_TRAINING,
} from "../../../../constants/constants";

import styles from "./сardExpulsionOrder.module.css";

function CardExpulsionOrder() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode, additionalAccess, orderNum } = location.state || {};

  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [options, setOptions] = useState(optionsInputExpulsionOrder);
  const [isLoading, setIsLoading] = useState(true);
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [saveKey, setSaveKey] = useState(false);

  const stateExpulsionOrder = useSelector((state) => state.expulsionOrderReducer);
  const optionsForSelectTrainingProgram = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.trainingProgramLibrary.map((item) => {
      return {
        value: item.id,
        label: item.sign,
        key: "programId",
      };
    });
  });
  const orderNumWatch = watch("orderNum");

  const handleButtonAddListener = (data) => {
    dispatch(updateSearchCardExpulsionOrder(data));
    navigate("/listenerTracking/add/searchListener");
  };

  const handleCloseApp = () => {
    navigate(-1);
  };

  const handleErrors = () => {
    let newErrors = {};
    stateExpulsionOrder.dataForTable.forEach((el) => {
      switch (true) {
        case !Boolean(el.statusNameId): {
          el.error = true;
          break;
        }
        case el.statusNameId === "3" && (!Boolean(el.startDate) || !Boolean(el.endDate)): {
          el.error = true;
          break;
        }
        case el.statusNameId === "2" &&
          (!Boolean(el.startDate) ||
            !Boolean(el.endDate) ||
            !Boolean(el.docNumCertificate) ||
            !Boolean(el.docDateCertificate)): {
          el.error = true;
          break;
        }
        case el.error: {
          el.error = true;
          break;
        }
        default:
          el.error = false;
      }
    });

    if (stateExpulsionOrder.dataForTable.find((el) => el.error === true)) {
      newErrors.errorsTable = "Заполните поле";
    }

    return Object.keys(newErrors).length > 0;
  };

  const handleSave = async (data) => {
    if (!handleErrors()) {
      const dataForJSON = stateExpulsionOrder.dataForTable.map((el) => {
        el.orderNum = data.orderNum;
        el.orderDate = data.orderDate;
        return el;
      });
      const json = JSON.stringify(dataForJSON);
      const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_SAVE_EXPULSION_ORDER, {
        method: "POST",
        body: json,
      });
      if (response.status !== 200) {
        const responseData = await response.text();
        setMessageNotificationWindow(responseData);
        setShowNotificationWindow(!showNotificationWindow);
      } else {
        const responseText = await response.text();
        setAppId(responseText);
        setShowResultModal(!showResultModal);
        setRegistrationResult("success");
      }
    } else {
      setSaveKey(true);
    }
  };

  const handleTableDataUpdate = (newData) => {
    dispatch(updateExpulsionTableData(newData)); // Вызываем действие для обновления данных через Redux
  };

  useEffect(() => {
    if (saveKey) handleErrors();
  }, [stateExpulsionOrder]);

  // Вынести запрос в redux
  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_GET_EXPULSION_ORDER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ orderNum }),
      });

      if (response.status !== 200) {
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      } else {
        const dataStatement = await response.json();
        dispatch({
          type: SET_DATA_FOR_VIEW_EXPULSION_ORDER,
          data: dataStatement,
        });
        setIsLoading(false);
      }
    }

    switch (mode) {
      case "add":
        setIsLoading(false);
        break;
      default:
        fetchData();
    }
  }, []);

  useEffect(() => {
    if (optionsForSelectTrainingProgram.length > 0 && options.programId.options.length <= 1) {
      const updatedOptions = {
        ...options,
        programId: {
          ...options.programId,
          options: [...options.programId.options, ...optionsForSelectTrainingProgram],
        },
      };
      setOptions(updatedOptions);
    }
  }, [optionsForSelectTrainingProgram]);

  useEffect(() => {
    setOptions(updateOptions(stateExpulsionOrder.dataForTable.length));
  }, [stateExpulsionOrder.dataForTable.length]);

  useEffect(() => {
    if (orderNumWatch) {
      dispatch(updateSearchCardOrderNum(orderNumWatch));
    }
  }, [orderNumWatch]);

  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }

  return (
    <Form className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>Приказ об отчислении</h2>
      <div className={styles["form-container"]}>
        {mode === "add" ? (
          <div className={styles["inputs-container"]}>
            {Object.values(options).map((option) => {
              switch (true) {
                case option.type === "selectWithSearch": {
                  return (
                    <SelectWithSearch
                      key={option.key}
                      mode={mode}
                      inputProps={option}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      dataForm={stateExpulsionOrder}
                    />
                  );
                }
                default:
                  return (
                    <InputForForm
                      key={option.key}
                      mode={mode}
                      register={register}
                      inputProps={option}
                      errors={errors}
                      setValue={setValue}
                      dataForm={stateExpulsionOrder}
                    />
                  );
              }
            })}
          </div>
        ) : (
          <div className={styles["view-block"]}>
            {Object.values(options).map((option) => {
              console.log("option", option);
              return (
                <div
                  key={option.key}
                  className={styles["text-block"]}>
                  <p className={styles["option-label"]}>{option.label}</p>
                  <p className={styles["option-value"]}>
                    {option.type === "date" && stateExpulsionOrder?.[option.key]
                      ? stateExpulsionOrder?.[option.key].split("-").reverse().join(".")
                      : option.type === "selectWithSearch"
                      ? option.options.find((elem) => elem.value === stateExpulsionOrder?.[option.key])
                          ?.label || "—"
                      : stateExpulsionOrder?.[option.key] || "—"}
                  </p>
                </div>
              );
            })}
          </div>
        )}
        {mode === "add" && additionalAccess?.addUser && (
          <button
            id={`add`}
            title={"Добавить слушателя"}
            className={styles["add-btn"]}
            onClick={handleSubmit(handleButtonAddListener)}>
            <span className={styles["plus-icon"]}></span>
            <p className={styles["buttons-text"]}>Добавить слушателя</p>
          </button>
        )}
        <EditableTableForKnoweledgeTest
          mode={mode}
          columns={columnsExpulsionOrderTable}
          handleTableDataUpdate={handleTableDataUpdate}
          tableData={stateExpulsionOrder.dataForTable}
          caption={"Список слушателей"}
        />
      </div>
      <div className={styles["buttons-block"]}>
        <div
          className={styles["close-btn"]}
          onClick={() => {
            handleCloseApp();
          }}>
          Закрыть
        </div>
        {mode !== "view" && Boolean(stateExpulsionOrder.dataForTable.length) && (
          <button
            className={styles["save-btn"]}
            onClick={handleSubmit(handleSave)}>
            {mode === "add" ? "Сохранить" : "Сохранить изменения"}
          </button>
        )}
      </div>
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
        />
      )}
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
      />
    </Form>
  );
}

export default CardExpulsionOrder;
